import { apiCallRemoveSilentBan } from "../../../api/user-api/api-call-remove-silent-ban";
import getCorePopUpStore from "../../core/core-popup-store";
import getCoreUIStore from "../../core/core-ui-store";

const removeSilentBanOnDatabase = async (userUUID: string) => {
  getCoreUIStore().setIsLoading("USER_ADVANCED", true);
  const { status, code } = await apiCallRemoveSilentBan({
    userUUID,
    pageName: "USER_ADVANCED"
  });
  getCoreUIStore().setIsLoading("USER_ADVANCED", false);
  if (status === "OK") {
    getCorePopUpStore().showSuccessMessage("SILENT_BAN_REMOVED_SUCCESSFULLY");
    return status;
  }
  getCorePopUpStore().showAlertMessage(code);
  return status;
};

export default removeSilentBanOnDatabase;
